import {Component} from 'react';
import h from 'react-hyperscript';
import './Intro.scss';
import {h3, p, subhead, eyebrow} from 'Components/Typography/Typography';
import Image from 'Components/Image/Image';
import BasicCard from 'Components/Cards/BasicCard';
import Button from 'Components/Buttons/Buttons';


class Intro extends Component {
  constructor(props) {
    super(props);
    this._isMounted = false;
    this.state = {
      mountedClass: 'fade-out',
    };
  }

  componentDidMount() {
    this._isMounted = true;
    this.setMountedClass();
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.setMountedClass();
  }

  setMountedClass() {
    let value;
    if (this._isMounted) {
      value = 'fade-in';
    } else {
      value = 'fade-out';
    }
    this.setState({
      mountedClass: value,
    });
  }

  saveAndContinue(e) {
    e.preventDefault();
    this.props.nextStep();
  }

  render() {
    return (
      h(BasicCard, {
        className: `${this.props.className} ${this.state.mountedClass}`,
        activeStep: this.props.activeStep,
      }, [
        h('div', {
          id: 'survey-intro__header',
        }, [
          h(h3, null, this.props.content.title),
          h(p, {
            className: 'text--grey padding-bottom--sm',
            id: 'survey-intro__desc',
          }, this.props.content.desc),
          h(p, {
            className: 'text--grey margin-top--sm',
            id: 'survey-intro__desc',
          }, this.props.content.descSecondary),
        ]),

        h('div', {
          key: 'overview-icons',
          id: 'survey-intro__icons',
        }, [

          h(eyebrow, null, this.props.content.surveyElementsTitle),
          h('ul', null, this.props.transformationElements.map((el, i) => {
            return (
              h('li', {
                key: el.id,
              }, [
                h(Image, {
                  key: `${el.id}--span`,
                  src: el.icon,
                }, null),
                h(subhead, {
                  key: `${el.id}--subhead`,
                }, el.title),
              ])
            );
          })),
        ]),

        h(Button, {
          key: 'get-started',
          to: '#',
          className: 'button--centered survey__cta',
          id: 'survey-intro__cta',
          onClick: (e) => {
            this.saveAndContinue(e);
          },
          type: 'basic'},
        'Get Started'
        ),
      ])
    );
  }
}

export default Intro;
